import React from 'react';
import { Tooltip as ToolTipComponent, TooltipProps } from 'react-bootstrap';
import './tooltip.scss';

interface CustomTooltipProps extends TooltipProps {
  tooltipText: string;
  className?: string;
}
export default function Overlay({
  tooltipText,
  className,
  ...props
}: CustomTooltipProps) {
  return (
    <ToolTipComponent
      className={`toolTipComponent ${className}`}
      id="overlay-example"
      {...props}
    >
      {tooltipText}
    </ToolTipComponent>
  );
}
